import React from 'react';

const ProductBottom = () => (
  <div className='comparison-table'>
    <h1>
      Feature Comparison
    </h1>
    <img decoding='async' src='https://360ra.com/wp-content/uploads/2025/10/Frame-6-scaled.png' alt='Comparison table' />
  </div>
);
export default ProductBottom;
